import { Theme, useStyles } from 'bold-ui'
import { blue, gray, green, pink, purple } from 'bold-ui/lib/styles/colors'
import { StatusAtendimento } from 'graphql/types.generated'
import { CSSProperties } from 'react'

export interface StatusAtendimentoType {
  styleBox: string
  styleBorder: string
  descricao: string
}

export const useListaAtendimentoStyles = () => {
  const { classes } = useStyles(createStatusAtendimentoStyles)

  const statusAtendimentoMap = new Map<StatusAtendimento, StatusAtendimentoType>()
  statusAtendimentoMap.set(StatusAtendimento.AGUARDANDO_ATENDIMENTO, {
    styleBox: classes.aguardandoAtendimentoBox,
    styleBorder: classes.aguardandoAtendimentoBorder,
    descricao: 'Aguardando atendimento',
  })
  statusAtendimentoMap.set(StatusAtendimento.ATENDIMENTO_REALIZADO, {
    styleBox: classes.atendimentoRealizadoBox,
    styleBorder: classes.atendimentoRealizadoBorder,
    descricao: 'Atendimento realizado',
  })
  statusAtendimentoMap.set(StatusAtendimento.EM_ATENDIMENTO, {
    styleBox: classes.emAtendimentoBox,
    styleBorder: classes.emAtendimentoBorder,
    descricao: 'Em atendimento',
  })
  statusAtendimentoMap.set(StatusAtendimento.EM_ESCUTA_INICIAL, {
    styleBox: classes.emEscutaInicialBox,
    styleBorder: classes.emEscutaInicialBorder,
    descricao: 'Em escuta inicial',
  })
  statusAtendimentoMap.set(StatusAtendimento.NAO_AGUARDOU, {
    styleBox: classes.naoAguardouBox,
    styleBorder: classes.naoAguardouBorder,
    descricao: 'Não aguardou',
  })

  return statusAtendimentoMap
}

export const createStatusAtendimentoStyles = (theme: Theme) => ({
  aguardandoAtendimentoBox: {
    backgroundImage: `linear-gradient(to top, ${green.c50}, ${green.c70})`,
  } as CSSProperties,

  aguardandoAtendimentoBorder: {
    borderBottomColor: green.c50,
    borderBottomWidth: '2px',
  } as CSSProperties,

  emAtendimentoBox: {
    backgroundImage: `linear-gradient(to top, ${purple.c20}, ${pink.c30})`,
  } as CSSProperties,

  emAtendimentoBorder: {
    borderBottomColor: purple.c20,
    borderBottomWidth: '2px',
  } as CSSProperties,

  emEscutaInicialBox: {
    backgroundImage: `linear-gradient(to top, ${pink.c40}, ${pink.c60})`,
  } as CSSProperties,

  emEscutaInicialBorder: {
    borderBottomColor: pink.c40,
    borderBottomWidth: '2px',
  } as CSSProperties,

  atendimentoRealizadoBox: {
    backgroundImage: `linear-gradient(to top, ${blue.c20}, ${blue.c40})`,
  } as CSSProperties,

  atendimentoRealizadoBorder: {
    borderBottomColor: blue.c20,
    borderBottomWidth: '2px',
  } as CSSProperties,

  naoAguardouBox: {
    backgroundImage: `linear-gradient(to top, ${gray.c70}, ${gray.c80})`,
  } as CSSProperties,

  naoAguardouBorder: {
    borderBottomColor: gray.c70,
    borderBottomWidth: '2px',
  } as CSSProperties,
})
